import { render, staticRenderFns } from "./mycredits.vue?vue&type=template&id=2c53f4c7&scoped=true"
import script from "./mycredits.vue?vue&type=script&lang=js"
export * from "./mycredits.vue?vue&type=script&lang=js"
import style0 from "./mycredits.vue?vue&type=style&index=0&id=2c53f4c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53f4c7",
  null
  
)

export default component.exports